import React from 'react';
import {
  Modal,
  Button,
} from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { SpText } from '../../components/DesignKit';
import { useSelector } from 'react-redux';

type Props = {
  visibility: Boolean,
  handleCancel: Function,
};

const TransactionFailModal = (props: Props) => {
  const {
    visibility,
    handleCancel,
  } = props;

  const isMobileView = useSelector(state => state.cartInfo.isMobileView);

  return (
    <Modal
      centered
      open={visibility}
      onCancel={handleCancel}
      width={isMobileView ? '95vw' : '50vw'}
      bodyStyle={{ height: '50vh', padding: 0 }}
      footer={null}
    >
      <div 
        className="d-flex flex-column align-items-center justify-content-center w-100 mt-4" 
        style={{ height: '50vh' }}
      >
        <div className="mb-4">
          {/* Massive icon to dominate the 50vh height */}
          <CloseCircleOutlined style={{ color: '#ff4d4f', fontSize: isMobileView ? '80px' : '120px' }} />
        </div>
        <SpText 
          fontSize={isMobileView ? "28px" : "42px"} 
          fontWeight="800" 
          color="#ff4d4f" 
          display="block"
          className="text-center"
        >
          Transaction Failed
        </SpText>
        <SpText 
          fontSize={isMobileView ? "18px" : "22px"} 
          color="#434343" 
          display="block"
          className="mt-4 text-center px-5"
        >
          Something went wrong. <br /> 
          Please check your details or try again later.
        </SpText>
        <div key="fail-footer" className="d-flex justify-content-center pb-5 mt-4">
          <Button 
            type="primary" 
            danger 
            size="large"
            style={{ height: '60px', width: '200px', fontSize: '20px' }}
            className="rounded-pill shadow"
            onClick={handleCancel}
          >
            Try Again
          </Button>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  isMobileView: state.cartInfo.isMobileView,
  shopInfo: state.cartInfo.shopInfo,
  browseMode: state.cartInfo.browseMode,
  userInfo: state.cartInfo.userInfo,
  selectedShopInfo: state.cartInfo.selectedShopInfo,
  itemsInfos: state.cartInfo.itemsInfos,
});

export default TransactionFailModal;
